export default __webpack_public_path__ + "static/media/de-safemars-whitepaper.c691c1e2.pdf";